<div class="sidebar-container d-flex flex-column justify-content-between">
    <div class="d-flex flex-column">
        <img src="assets/images/logo.png" alt="" width="240px" />
        <nav class="navbar-container d-flex flex-column gap-1">
            @for (menuItem of userTypeMenuItems(); track $index)
            {
                <app-menu-item [menuItem]="menuItem" [isSelected]="selectedItem === menuItem.value"/>
            }
        </nav>
    </div>
    <div class="d-flex flex-column gap-3">
        <nav class="navbar-container d-flex flex-column gap-1">
            @for (menuItem of userTypeBottomMenuItems(); track $index)
            {
                <app-menu-item [menuItem]="menuItem" [isSelected]="selectedItem === menuItem.value"/>
            }
        </nav>
        <div class="d-flex language-toggle-container justify-content-between align-items-center gap-2">
            <div class="d-flex align-items-center gap-2">
                <svg-icon src="assets/icons/world.svg" class="language-icon d-flex align-items-center justify-content-center"/>
                <p class="nunito-semibold">{{'GENERAL.LANGUAGE_SWITCHER_TITLE' | translate}}</p>
            </div>
            <div class="language-switcher d-flex align-items-center position-relative" (click)="toggleLanguage()">
                <div [@activeLanguageState]="isActiveLanguage(langs[0])" class="active-overlay position-absolute"></div>
                @for (lang of langs; track $index)
                {
                    <p [ngClass]="isActiveLanguage(lang) ? 'nunito-bold' : 'nunito-regular'" [class.active]="isActiveLanguage(lang)">{{lang | uppercase}}</p>
                }
            </div>  
        </div>
    </div>
</div>
